const config = {
    apiUrl: 'https://hicomtechai.co.kr/api',
  };
  
  export default config;